import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import HomePage from './Pages/HomePage/HomePage';
import ServicesPage from './Pages/ServicesPage/ServicesPage';
import AboutPage from './Pages/AboutPage/AboutPage';
import ContactPage from './Pages/ContactPage/ContactPage';
import Header from './Components/HeaderComponent/Header';
import Footer from './Components/FooterComponent/Footer';
import { Helmet } from 'react-helmet';
import Verfication from './Pages/Verification/Verfication';

function App() {
  return (
    <>
      <Helmet>
        <title>LD InterTech Innovation - Home</title>
        <link rel="canonical" href="https://ldintertech.com/" />
        <meta name="description" content="LD InterTech Innovation delivers innovative technology and marketing solutions, offering expert services in hardware, software, cloud systems, and digital marketing to help businesses succeed in the digital age." />
        <meta name="keywords" content="technology and marketing solutions, digital transformation services, innovative technology consulting, cloud system integration, hardware and software development, custom cloud technologies, business digital transformation, cutting-edge marketing strategies, digital marketing for businesses, future-focused business solutions, advanced hardware solutions, software solutions for enterprises, data-driven marketing, tech-driven business growth, custom software and cloud solutions, innovative digital solutions, technology consulting for businesses, smart cloud services, market positioning strategies, business innovation and technology, cloud integration experts, digital strategy consulting, end-to-end tech solutions, business transformation experts" />
        <meta name="author" content="LD InterTech Innovation" />
        <meta name="robots" content="index, follow" />
        <html lang="en" />
      </Helmet>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path='/' Component={HomePage} />
          <Route path='home' Component={HomePage} />
          <Route path='services' Component={ServicesPage} />
          <Route path="/services/:serviceName" element={<ServicesPage />} />
          <Route path='about' Component={AboutPage} />
          <Route path='contact' Component={ContactPage} />
          <Route path='verify' Component={Verfication} />
          <Route path='*' Component={HomePage} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;
